import { defineMessages } from 'react-intl';

const scope = 'app.components.LicenseDataContainer';

export const messages = defineMessages({
  cityField: {
    id: `${scope}.cityField`,
    defaultMessage: 'City',
  },
  stateCodeField: {
    id: `${scope}.stateCodeField`,
    defaultMessage: 'State code',
  },
  stateCodeIsoField: {
    id: `${scope}.stateCodeIsoField`,
    defaultMessage: 'State code ISO',
  },
  countryCodeField: {
    id: `${scope}.countryCodeField`,
    defaultMessage: 'Country code',
  },
  countryCodeIsoField: {
    id: `${scope}.countryCodeIsoField`,
    defaultMessage: 'Country code ISO',
  },
  employerContactNameField: {
    id: `${scope}.employerContactNameField`,
    defaultMessage: 'Employer contact name',
  },
  employerNameField: {
    id: `${scope}.employerNameField`,
    defaultMessage: 'Employer name',
  },
  startMonthField: {
    id: `${scope}.startMonthField`,
    defaultMessage: 'Start month',
  },
  startYearField: {
    id: `${scope}.startYearField`,
    defaultMessage: 'Start year',
  },
  endMonthField: {
    id: `${scope}.endMonthField`,
    defaultMessage: 'End month',
  },
  endYearField: {
    id: `${scope}.endYearField`,
    defaultMessage: 'End year',
  },
  activeField: {
    id: `${scope}.activeField`,
    defaultMessage: 'Active',
  },
  jobTitleField: {
    id: `${scope}.jobTitleField`,
    defaultMessage: 'Job title',
  },
  present: {
    id: `${scope}.present`,
    defaultMessage: 'Present',
  },
  noEmployerDetails: {
    id: `${scope}.noEmployerDetails`,
    defaultMessage: 'No employer details provided.',
  },
});
